
import { Component, Vue } from 'vue-property-decorator';
import wx from 'weixin-sdk-js';
import axios from '@/services/axios';
import { ProcessItem, Judge, Prize } from '@/types/salon';
import AlloyFinger from 'alloyfinger';

declare const window: any;

@Component
export default class Chengdu extends Vue {
  private pageCurrent = 1;
  private process: ProcessItem[] = [
    {
      time: '13:00 - 13:30',
      desc: '签到'
    },
    {
      time: '13:30 - 13:35',
      desc: '开场'
    },
    {
      time: '13:35 - 13:45',
      desc: '腾讯独立游戏孵化器创立简介',
      author: '—— 腾讯独立游戏孵化器负责人 诸一楠'
    },
    {
      time: '13:45 - 14:00',
      desc: '鹅厂里地道的独立游戏人',
      author: '—— 腾讯独立游戏孵化器PM 朱国天'
    },
    {
      time: '14:00 - 14:15',
      desc: '游戏孵化过程中如何多维度提升游戏品质',
      author: '—— 腾讯独立游戏孵化器PM 袁帅'
    },
    {
      time: '14:15 - 15:00',
      desc: '聊聊做独游5年的那些坑',
      author: '—— 龙游天下创始人 刘舒涵'
    },
    {
      time: '15:00 - 15:20',
      desc: '茶歇'
    },
    {
      time: '15:20 - 16:05',
      desc: '从独立游戏走向中型ARPG的受苦历程',
      author: '—— SenseGames 创始人 杨滨'
    },
    {
      time: '16:05 - 16:50',
      desc: '游戏创新新思路：主题立项法',
      author: '—— 腾讯互娱游戏研究中心 胡敏'
    },
    {
      time: '16:50 - 17:00',
      desc: '抽奖活动'
    }
  ];

  private judges: Judge[] = [
    {
      avatar: require('assets/img/basic/judges/zyn.png'),
      name: '诸一楠',
      title: '腾讯独立游戏孵化器负责人'
    },
    {
      avatar: require('assets/img/basic/judges/lsh.png'),
      name: '刘舒涵',
      title: '龙游天下创始人'
    },
    {
      avatar: require('assets/img/basic/judges/yb.png'),
      name: '杨滨',
      title: 'SenseGames 创始人'
    },
    {
      avatar: require('assets/img/basic/judges/hm.png'),
      name: '胡敏',
      title: '腾讯互娱游戏研究中心<br />平台建设组负责人'
    }
  ];

  private prizes: Prize[] = [
    {
      name: 'xbox-one',
      figure: require('assets/img/basic/prizes/xbox-one.png'),
      desc: 'XBOX ONE无限手柄<br />1个'
    },
    {
      name: 'mouse',
      figure: require('assets/img/basic/prizes/mouse.png'),
      desc: '雷蛇炼狱蝰蛇鼠标<br />3个'
    },
    {
      name: 'keyboard',
      figure: require('assets/img/basic/prizes/keyboard.png'),
      desc: '海盗船机械键盘<br />2个'
    },
    {
      name: 'ns-card',
      figure: require('assets/img/basic/prizes/ns-card.png'),
      desc: 'NS热门游戏卡'
    },
    {
      name: 'qqtony',
      figure: require('assets/img/basic/prizes/qqtony.png'),
      desc: 'QQ公仔'
    }
  ];

  private partnerMain: string[] = [
    require('assets/img/basic/partners/main/daxue.png'),
    require('assets/img/basic/partners/main/gwb.png')
  ];

  private partnerUnion: string[] = [
    require('assets/img/basic/partners/union/yxcg.png'),
    require('assets/img/basic/partners/union/yzw.png')
  ];

  mounted(): void {
    let page = new AlloyFinger('.banner', {
      swipe: (evt: any) => {
        if (evt.direction === 'Up') {
          this.pageCurrent = 2;
          evt.preventDefault();
        }
      }
    });

    axios.get(`/mobile/weixin/config?url=${encodeURIComponent(window.location.href)}`).then(res => {
      wx.config(res.data.data);
      wx.ready(() => {
        const shareData = {
          title: '腾讯独立游戏开发者沙龙',
          desc: '资深从业者研发经验分享，腾讯独立游戏孵化器资源深度对接。',
          imgUrl: 'https://gwb.qpic.cn/h5/share_figure/salon2021_share.png',
          link: `${window.location.origin}${window.location.pathname}#/chengdu`,
          success: () => {
            /* global MtaH5 */
            if (window.beacon) {
              window.beacon.onDirectUserAction('share-page', {
                page: location.href,
                id: 'gwb_salon_chengdu_2021',
                name: '2021线下沙龙报名成都站',
                type: 'share_wx',
                user_id: '' //可空
              });
            }
          }
        };
        wx.onMenuShareTimeline(shareData);
        wx.onMenuShareAppMessage(shareData);
      });
    });
  }
}
